import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Attachment} from "../../../../attachments/models/attachment.model";

require('./bringoz-images-viewer.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-images-viewer',
  templateUrl: './bringoz-images-viewer.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozImagesViewerComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() attachments: Attachment[];
  @Input() height: any;
  @Input() canUpload: boolean;
  @Output() onUploadImage = new EventEmitter<any>();

  public currentViewedAttachment: Attachment;
  public currentViewedImageIndex: number;
  public totalImages: number;
  public pattern = "'.pdf,.tif,.tiff,.bmp,.jpeg,.jpg,.gif,.png,.eps,.raw,.cr2,.nef,.orf,.sr2'"

  ngOnInit() {
    this._init();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.attachments && !changes.attachments.isFirstChange()) {
      this._init();
    }
  }

  ngAfterViewInit() {
    const fileUploadInput = document.getElementById('file-upload');
    fileUploadInput.addEventListener('change', (e) => {
      const input = e.target as HTMLInputElement;
      if (input.files && input.files.length > 0) {
        const files = Array.from(input.files);
        this.onUploadImage.emit({files, invalidFiles: []}); // Adjust as needed
      }
    })
  }

  nextImage() {
    const nextIndex = (this.currentViewedImageIndex + 1) === this.attachments.length ? 0 : this.currentViewedImageIndex + 1;
    this.currentViewedAttachment = this.attachments[nextIndex]
    this.currentViewedImageIndex = nextIndex;
  }

  previousImage() {
    const nextIndex = this.currentViewedImageIndex ? this.currentViewedImageIndex - 1 : this.attachments.length - 1;
    this.currentViewedAttachment = this.attachments[nextIndex]
    this.currentViewedImageIndex = nextIndex;
  }

  private _init() {
    this.currentViewedAttachment = this.attachments[0];
    if (this.attachments?.length) {
      this.currentViewedImageIndex = 0;
    }
    this.totalImages = this.attachments?.length;
  }

}
